import { graphql } from "gatsby";
import React from "react";
import { CompletedProjects } from "../CompletedProjects/CompletedProjects";
import "./styles.css";

const ShopEquipmentShoppingRoomProjects = ({ title, examples }) => {
  return <CompletedProjects title={title} examples={examples} />;
};

ShopEquipmentShoppingRoomProjects.getLivePreviewData = ({ data, getAsset }) => ({
  shopEquipmentShoppingRoomProjects: {
    ...data.shopEquipmentShoppingRoomProjects,
    examples: data.shopEquipmentShoppingRoomProjects.examples.map(example => ({
      ...example,
      photo: getAsset(example.photo).url,
    })),
  },
});

const shopEquipmentShoppingRoomProjectsQuery = graphql`
  fragment ShopEquipmentShoppingRoomProjectsFragment on MarkdownRemarkFrontmatter {
    shopEquipmentShoppingRoomProjects {
      title
      examples {
        photo {
          childImageSharp {
            fluid(maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        alt
        title
        description
      }
    }
  }
`;

export { ShopEquipmentShoppingRoomProjects, shopEquipmentShoppingRoomProjectsQuery };
